import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { QuoteForm } from './components/QuoteForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-[#FFFDF6] font-heading" data-id="element-0" data-mp="2rit14zvovkns">
      <Nav data-id="element-1" data-mp="2mmlwdaf14f7f" />
      <main data-id="element-2" data-mp="2mn5bkjdaophr">
        <Hero data-id="element-3" data-mp="2mndr6j0sy8wn" />
        <Marquee data-id="element-4" data-mp="2mjpwhgjmfggc" />
        <Services data-id="element-5" data-mp="31aqfuglwour9" />
        <Process data-id="element-6" data-mp="31b8ko1mmwhas" />
        <Testimonials data-id="element-7" data-mp="31bs0ncsq4vm6" />
        <Faq data-id="element-8" data-mp="31c1hoavsjsfq" />
        <QuoteForm data-id="element-9" data-mp="31ctf7r8y808n" />
      </main>
      <Footer data-id="element-10" data-mp="2wjgqlh49rtfw" />
    </div>;
}